var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-inline-block"},[_c('gl-badge',{ref:"badge",attrs:{"variant":"info","icon":"check-circle-dashed"}}),_vm._v(" "),_c('gl-popover',{ref:"popover",attrs:{"content":_vm.__(
        'The vulnerability is no longer detected. Verify the vulnerability has been fixed or removed before changing its status.',
      ),"target":_vm.target,"title":_vm.__('Vulnerability remediated. Review before resolving.'),"placement":"top"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }